export interface CitationOfficerDto {
    id?: number;
    name?: string | null;
}
